export const siteEvChargersModuleAccessKeys = {
  all: ["site", "ev-chargers-module-access"] as const,
};
